import React, { useState, useEffect, useRef } from "react";
import { sbaAxios } from "../../utils/sbaAxios";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import { SBADropDown, SBAMultiSelectCheck, SBAComboBox } from "../../UiComponents/SBADropDown";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { applicationsListAPI, getAppSettings, updateAppConfigValues } from "../../../config/apiConfig";
import { ServerInfo } from '../ServerInfo/ServerInfo';
import { Classfications } from "../Classifications/classifications";


export const ApplicationSettings = () => {
    const usersLastLoginRef = useRef();
    const Gstate = useSelector((state) => state) || {};
    const dispatch = useDispatch();
    const history = useNavigate();
    const [show, setshow] = useState(false);
    const [render, setRender] = useState(true);
    const [griddata, setGriddata] = useState([]);
    const [applicationdata, setApplicationdata] = useState([]);
    const [selectedapplication, setselectedapplication] = useState([]);
    const [configurationvalue, setconfigurationvalue] = useState([]);
    const [configurationname, setconfigurationname] = useState([]);
    const [Encrypted, setEncrypted] = useState(false);
    const [AppconfigId, setAppconfigId] = useState([]);
    const [activeTab, setActiveTab] = useState("EmailRuleSetup")


    let Level = [{ BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` }];
    Level = render ? Level : [...Level, { BreadCrumb: `Application Settings`, Routes: `${UrlPath.ApplicationSettings}`, },];
    useEffect(() => {

    }, []);
    useEffect(() => {
        document.title = `Application Settings`;
        setRender(false);
        getApplicationlistData();

    }, []);
    // get Application  List 
    const getApplicationlistData = () => {
        sbaAxios({ url: applicationsListAPI }).then(res => {
            setApplicationdata(res);

        }).catch(e => {
            console.log(e, 'Error Loading the Application settings Data');
            setApplicationdata([]);
        })
    };
    // get Application Grid Data 
    const getApplicationGridData = async (appId) => {

        try {
            const response = await sbaAxios({
                url: `${getAppSettings}/${appId}`,
                method: 'get',
            });
            if (response) {
                setGriddata(response);
            }
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')
        };
    };
    const ApplicationOnchange = (e) => {
        if (e.value) {
            getApplicationGridData(e.value.EnumValue);
            setselectedapplication(e.value);
        }
    };
    const ActionRenderer = (props) => {
        const Editdatas = props.data;
        const handleEditClick = () => {
            setshow(true);
            setAppconfigId(Editdatas.AppConfigId)
            setconfigurationvalue(Editdatas.AppConfigValue);
            setconfigurationname(Editdatas.AppConfigName)
            setEncrypted(Editdatas.IsEncrypted)
        };
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-edit"
                    style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}
                ></i>
            </div>
        );
    };
    var coldef = [
        {
            field: "AppConfigName",
            headerName: "Config Name",
        },
        {
            field: "AppConfigValue",
            headerName: "Config Value",

        },
        {
            field: "IsEncrypted",
            headerName: "Encrypted",
            width: 100,
            minWidth: 50,
            maxWidth: 150

        },
        {
            field: "",
            headerName: "Edit",
            cellRenderer: ActionRenderer,
            width: 100,
            minWidth: 50,
            maxWidth: 150

        },

    ];
    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter',resizable:true
    }
    // Application Setting save data
    const SaveApplicationsettings = () => {
        let ifsave = true;
        const savedata = {
            "appId": selectedapplication.EnumValue,
            "appConfigId": AppconfigId,
            "appConfigName": configurationname,
            "appConfigValue": configurationvalue,
            "isEncrypted": Encrypted

        }
        if (!configurationvalue) {
            ifsave = false;
            SBNotify({ Msg: " Please Enter Configuration Value ", type: "error" });
        }

        if (ifsave) {

            sbaAxios({
                url: `${updateAppConfigValues}`,
                method: "post",
                data: savedata
            }).then((res) => {
                SBNotify({
                    Msg: "Application Settings updated Successfully",
                    type: "success",
                });
                setshow(false);
                getApplicationGridData(selectedapplication.EnumValue);
            })
                .catch((error) => {
                    SBNotify({ Msg: error, type: "error" });
                });
        }
    };
    const handleTabChange = (eventKey) => {
        setActiveTab(eventKey);
    };
    return (
        <>
            <TopBar label={"Application Settings"} />
            <div className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div className="bg-white p-3 border rounded">

                        <Tabs
                            activeKey={activeTab}
                            id="uncontrolled-tab-example"
                            className="ms-3"
                            onSelect={handleTabChange}
                        >
                            <Tab eventKey="Serverinfo" title="Server Info" >
                                {activeTab === "Serverinfo" && <ServerInfo></ServerInfo>}
                            </Tab>
                            <Tab eventKey="EmailRuleSetup" title="Email Rule Setup">
                               {activeTab === "EmailRuleSetup" &&  <div className="border p-3">

                                <div className="d-flex ">
                                    <div className="mb-4 col-3">
                                        <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Email Rule Type</label>
                                        <div>
                                            <SBAComboBox
                                                className="w-100"
                                                data={applicationdata}
                                                value={selectedapplication}
                                                textField={"EnumName"}
                                                valueField={"EnumValue"}
                                                onChange={ApplicationOnchange}
                                                popupSettings={{ className: "modalDD" }}
                                                placeholder="---Please Select---"
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="ag-theme-alpine m-1 " style={{ width: '75%', height: '700px' }}>
                                    <AgGridReact
                                        columnDefs={coldef}
                                        rowData={griddata}
                                        defaultColDef={defaultColDef}
                                        enableBrowserTooltips={true}
                                        tooltipInteraction={true}

                                    />
                                </div>
                                </div>}

                            </Tab>
                            <Tab eventKey="Classification" title="Classification" >
                                {activeTab === "Classification" && <Classfications></Classfications>}
                            </Tab>
                        </Tabs>
                    </div>
                </div>
                <SBADrawer
                    open={show}
                    setOpen={setshow}
                    close={false}
                    title={"Application Settings"}
                >
                    <div className="drawer">
                        <div>
                            <div className="col-lg-12 px-0">
                                <div className="row m-2">
                                    <div className="row mb-4">
                                        <div className="col-md-5">
                                            <label className="mb-1 label">Configuration Name</label>
                                            <div>

                                                <input
                                                    className="form-control w-100"
                                                    type="text"
                                                    value={configurationname}
                                                    disabled
                                                />

                                            </div>
                                        </div>
                                        <div className="col-md-5">
                                            <label className="mb-1 label">Configuration Value<span class="mandatory">*</span></label>
                                            <div>
                                                <input
                                                    className="form-control w-100"
                                                    type="text"
                                                    value={configurationvalue}
                                                    onChange={(e) => setconfigurationvalue(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-4">
                                        <div className="col-md-5">
                                            <label className="checkbox-label d-block">
                                                <input
                                                    type="checkbox"
                                                    className="checkbox-input"
                                                    name="Encrypted"
                                                    checked={Encrypted}
                                                    onChange={(e) => {
                                                        setEncrypted(e.target.checked)

                                                    }}
                                                />
                                                <span className="mx-2">Encrypted</span>
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="mt-5">

                                <button className="p-sm-btn mx-1" onClick={SaveApplicationsettings} >
                                    Save
                                </button>
                                <button className="s-sm-btn mx-1" onClick={() => {
                                    setshow(false);
                                }}>
                                    Cancel
                                </button>

                            </div>
                        </div>
                    </div>
                </SBADrawer>
                <ToastContainer></ToastContainer>
            </div>
        </>
    );
};
